import { createAction } from 'utils/reduxUtil';
import { ACCOUNTS_RESET } from 'containers/accounts/store/accountsConstants';

/* istanbul ignore file */

export const accountsReset = () => createAction(ACCOUNTS_RESET);
